var _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSkymonitorVerticalNameLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "155.60625mm",
    height: "125.34675mm",
    viewBox: "0 0 155.60625 125.34675",
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-24.770533,-103.4692)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.177019,
      fill: "#00000e",
      strokeWidth: 10.7,
      strokeLinecap: "round",
      strokeMiterlimit: 7.2
    },
    d: "M 43.351772,189.76625 H 151.14078 l 20.27955,-22.68806 8.95643,-29.51665 -17.01196,-25.29504 -24.72871,-8.79731 -25.5123,8.91886 -10.67455,21.14359 -20.653441,-11.24692 -19.502693,7.77662 -7.489921,21.26089 -20.810074,-0.99764 -9.222579,22.84292 z",
    id: "path233"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#00ccff",
      fillOpacity: 1,
      strokeWidth: 10.7,
      strokeLinecap: "round",
      strokeMiterlimit: 7.2
    },
    d: "m 54.803185,151.32223 25.663432,4.08979 -18.173512,-25.35068 z",
    id: "path286"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#0088aa",
      fillOpacity: 1,
      strokeWidth: 10.7,
      strokeLinecap: "round",
      strokeMiterlimit: 7.2
    },
    d: "m 80.466617,155.41202 1.329182,-33.1273 -19.502694,7.77662 z",
    id: "path288"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#00aad4",
      fillOpacity: 1,
      strokeWidth: 10.7,
      strokeLinecap: "round",
      strokeMiterlimit: 7.2
    },
    d: "m 102.44924,133.53164 -21.982623,21.88038 1.329182,-33.1273 20.653441,11.24692",
    id: "path290"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#2ad4ff",
      fillOpacity: 1,
      strokeWidth: 10.7,
      strokeLinecap: "round",
      strokeMiterlimit: 7.2
    },
    d: "M 43.351772,189.76625 80.466617,155.41202 54.803185,151.32223 Z",
    id: "path292"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#0088aa",
      fillOpacity: 1,
      strokeWidth: 10.7,
      strokeLinecap: "round",
      strokeMiterlimit: 7.2
    },
    d: "M 43.351772,189.76625 H 97.246275 L 80.466617,155.41202 Z",
    id: "path294"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#0088aa",
      fillOpacity: 1,
      strokeWidth: 10.7,
      strokeLinecap: "round",
      strokeMiterlimit: 7.2
    },
    d: "m 80.466617,155.41202 21.982623,-21.88038 23.92527,26.17465 -45.907893,-4.29427",
    id: "path296"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#006680",
      fillOpacity: 1,
      strokeWidth: 10.7,
      strokeLinecap: "round",
      strokeMiterlimit: 7.2
    },
    d: "m 80.466617,155.41202 45.907893,4.29427 -29.128235,30.05996 z",
    id: "path298"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#00aad4",
      fillOpacity: 1,
      strokeWidth: 10.7,
      strokeLinecap: "round",
      strokeMiterlimit: 7.2
    },
    d: "m 126.37451,159.70629 5.62346,30.05996 H 97.246275 l 29.128235,-30.05996",
    id: "path300"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#2ad4ff",
      fillOpacity: 1,
      strokeWidth: 10.7,
      strokeLinecap: "round",
      strokeMiterlimit: 7.2
    },
    d: "m 151.14078,189.76625 -24.76627,-30.05996 5.62346,30.05996 h 19.14281",
    id: "path302"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#0088aa",
      fillOpacity: 1,
      strokeWidth: 10.7,
      strokeLinecap: "round",
      strokeMiterlimit: 7.2
    },
    d: "m 151.14078,189.76625 2.56467,-25.79449 -27.33094,-4.26547 24.76627,30.05996",
    id: "path2529"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#55ddff",
      fillOpacity: 1,
      strokeWidth: 10.7,
      strokeLinecap: "round",
      strokeMiterlimit: 7.2
    },
    d: "m 171.42033,167.07819 -17.71488,-3.10643 -2.56467,25.79449 20.27955,-22.68806",
    id: "path2531"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#00aad4",
      fillOpacity: 1,
      strokeWidth: 10.7,
      strokeLinecap: "round",
      strokeMiterlimit: 7.2
    },
    d: "m 126.37451,159.70629 54.00225,-22.14475 -8.95643,29.51665 -45.04582,-7.3719",
    id: "path2609"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#55ddff",
      fillOpacity: 1,
      strokeWidth: 10.7,
      strokeLinecap: "round",
      strokeMiterlimit: 7.2
    },
    d: "m 126.37451,159.70629 3.16958,-31.38913 34.12108,16.09731 z",
    id: "path2621"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#0088aa",
      fillOpacity: 1,
      strokeWidth: 10.7,
      strokeLinecap: "round",
      strokeMiterlimit: 7.2
    },
    d: "m 163.66517,144.41447 -0.30037,-32.14797 17.01196,25.29504 -16.71159,6.85293",
    id: "path2623"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#00aad4",
      fillOpacity: 1,
      strokeWidth: 10.7,
      strokeLinecap: "round",
      strokeMiterlimit: 7.2
    },
    d: "m 129.54409,128.31716 33.82071,-16.05066 0.30037,32.14797 z",
    id: "path2625"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#00ccff",
      fillOpacity: 1,
      strokeWidth: 10.7,
      strokeLinecap: "round",
      strokeMiterlimit: 7.2
    },
    d: "m 138.63609,103.46919 -9.092,24.84797 33.82071,-16.05066 z",
    id: "path2627"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#0088aa",
      fillOpacity: 1,
      strokeWidth: 10.7,
      strokeLinecap: "round",
      strokeMiterlimit: 7.2
    },
    d: "m 113.12379,112.38805 25.5123,-8.91886 -9.092,24.84797 -16.4203,-15.92911",
    id: "path2629"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#00ccff",
      fillOpacity: 1,
      strokeWidth: 10.7,
      strokeLinecap: "round",
      strokeMiterlimit: 7.2
    },
    d: "m 102.44924,133.53164 10.67455,-21.14359 16.4203,15.92911 z",
    id: "path2631"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#00aad4",
      fillOpacity: 1,
      strokeWidth: 10.7,
      strokeLinecap: "round",
      strokeMiterlimit: 7.2
    },
    d: "m 102.44924,133.53164 23.92527,26.17465 3.16958,-31.38913 -27.09485,5.21448",
    id: "path2633"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#00ccff",
      fillOpacity: 1,
      strokeWidth: 10.7,
      strokeLinecap: "round",
      strokeMiterlimit: 7.2
    },
    d: "M 24.770532,173.16751 54.803185,151.32223 33.993111,150.32459 Z",
    id: "path2689"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#00aad4",
      fillOpacity: 1,
      strokeWidth: 10.7,
      strokeLinecap: "round",
      strokeMiterlimit: 7.2
    },
    d: "m 24.770532,173.16751 18.58124,16.59874 11.451413,-38.44402 z",
    id: "path2691"
  }), /*#__PURE__*/React.createElement("g", {
    "aria-label": "SKY:Monitor",
    id: "text309",
    style: {
      fontSize: "31.75px",
      fontFamily: "'Fira Code'",
      InkscapeFontSpecification: "'Fira Code'",
      fill: "#333333",
      strokeWidth: 10.7,
      strokeLinecap: "round",
      strokeMiterlimit: 7.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 28.268318,224.30745 v -1.143 q 0,-0.34925 0.34925,-0.34925 h 0.92075 q 0.34925,0 0.34925,0.34925 v 1.04775 q 0,3.175 3.07975,3.175 h 3.302 q 3.07975,0 3.07975,-3.20675 v -1.3335 q 0,-1.397 -1.143,-2.19075 -1.143,-0.79375 -2.76225,-1.143 -1.61925,-0.34925 -3.27025,-0.73025 -1.61925,-0.381 -2.76225,-1.397 -1.143,-1.016 -1.143,-2.7305 v -1.74625 q 0,-2.0955 1.2065,-3.302 1.2065,-1.2065 3.27025,-1.2065 h 3.683 q 2.06375,0 3.27025,1.2065 1.2065,1.2065 1.2065,3.302 v 0.889 q 0,0.34925 -0.34925,0.34925 h -0.92075 q -0.34925,0 -0.34925,-0.34925 v -0.79375 q 0,-3.175 -3.07975,-3.175 h -3.27025 q -3.048,0 -3.048,3.2385 v 1.5875 q 0,2.19075 3.90525,2.95275 1.61925,0.3175 3.2385,0.73025 1.651,0.41275 2.794,1.49225 1.143,1.0795 1.143,2.921 v 1.55575 q 0,2.0955 -1.2065,3.302 -1.2065,1.2065 -3.27025,1.2065 h -3.7465 q -2.06375,0 -3.27025,-1.2065 -1.2065,-1.2065 -1.2065,-3.302 z",
    style: {
      fontFamily: "Rajdhani",
      InkscapeFontSpecification: "Rajdhani"
    },
    id: "path789"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 47.477077,228.81595 h -0.92075 q -0.3175,0 -0.3175,-0.381 V 208.7817 q 0,-0.381 0.3175,-0.381 h 0.92075 q 0.34925,0 0.34925,0.381 v 11.71575 h 0.127 q 0.1905,-0.508 0.5715,-1.04775 l 8.0645,-10.668 q 0.28575,-0.381 0.66675,-0.381 h 1.11125 q 0.41275,0 0.127,0.381 l -6.38175,8.54075 7.366,11.1125 q 0.254,0.381 -0.1905,0.381 h -0.889 q -0.47625,0 -0.6985,-0.381 l -6.604,-9.906 -3.27025,3.937 v 5.969 q 0,0.381 -0.34925,0.381 z",
    style: {
      fontFamily: "Rajdhani",
      InkscapeFontSpecification: "Rajdhani"
    },
    id: "path791"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 68.654349,228.81595 h -0.92075 q -0.34925,0 -0.34925,-0.381 v -7.33425 l -6.1595,-12.319 q -0.1905,-0.381 0.22225,-0.381 h 1.143 q 0.28575,0 0.4445,0.381 l 5.08,10.38225 h 0.15875 l 5.04825,-10.38225 q 0.15875,-0.381 0.4445,-0.381 h 1.17475 q 0.34925,0 0.22225,0.381 l -6.19125,12.319 v 7.33425 q 0,0.381 -0.3175,0.381 z",
    style: {
      fontFamily: "Rajdhani",
      InkscapeFontSpecification: "Rajdhani"
    },
    id: "path793"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 79.925601,212.9727 v 3.81 q 0,0.34925 -0.3175,0.34925 h -1.11125 q -0.34925,0 -0.34925,-0.34925 v -3.81 q 0,-0.34925 0.34925,-0.34925 h 1.11125 q 0.3175,0 0.3175,0.34925 z m 0,11.684 v 3.77825 q 0,0.381 -0.3175,0.381 h -1.11125 q -0.34925,0 -0.34925,-0.381 v -3.77825 q 0,-0.34925 0.34925,-0.34925 h 1.11125 q 0.3175,0 0.3175,0.34925 z",
    style: {
      fontFamily: "Rajdhani",
      InkscapeFontSpecification: "Rajdhani"
    },
    id: "path795"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 99.451849,208.4007 h 1.714501 q 0.3175,0 0.3175,0.381 v 19.65325 q 0,0.381 -0.3175,0.381 h -0.92075 q -0.349251,0 -0.349251,-0.381 v -17.5895 h -0.127 l -5.61975,13.17625 q -0.1905,0.34925 -0.47625,0.34925 h -1.04775 q -0.3175,0 -0.4445,-0.34925 l -5.715,-13.208 h -0.127 v 17.62125 q 0,0.381 -0.3175,0.381 h -0.92075 q -0.3175,0 -0.3175,-0.381 V 208.7817 q 0,-0.381 0.3175,-0.381 h 1.7145 q 0.22225,0 0.28575,0.1905 l 5.969,13.93825 h 0.127 l 5.969,-13.93825 q 0.0635,-0.1905 0.28575,-0.1905 z",
    style: {
      fontFamily: "Rajdhani",
      InkscapeFontSpecification: "Rajdhani"
    },
    id: "path797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 113.42183,228.81595 h -2.7305 q -2.06375,0 -3.27025,-1.2065 -1.17475,-1.2065 -1.17475,-3.302 v -7.1755 q 0,-2.0955 1.17475,-3.302 1.2065,-1.2065 3.27025,-1.2065 h 2.7305 q 2.06375,0 3.27025,1.2065 1.2065,1.2065 1.2065,3.302 v 7.1755 q 0,2.0955 -1.2065,3.302 -1.2065,1.2065 -3.27025,1.2065 z m -2.6035,-1.42875 h 2.4765 q 1.4605,0 2.2225,-0.79375 0.79375,-0.8255 0.79375,-2.31775 v -7.112 q 0,-1.49225 -0.79375,-2.286 -0.762,-0.8255 -2.2225,-0.8255 h -2.4765 q -1.4605,0 -2.2225,0.8255 -0.762,0.79375 -0.762,2.286 v 7.112 q 0,1.49225 0.762,2.31775 0.762,0.79375 2.2225,0.79375 z",
    style: {
      fontFamily: "Rajdhani",
      InkscapeFontSpecification: "Rajdhani"
    },
    id: "path799"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 123.55008,228.81595 h -0.92075 q -0.3175,0 -0.3175,-0.381 v -15.4305 q 0,-0.381 0.3175,-0.381 h 0.92075 q 0.34925,0 0.34925,0.381 v 1.27 h 0.127 q 0.889,-1.651 3.302,-1.651 h 2.0955 q 2.032,0 3.20675,1.2065 1.17475,1.2065 1.17475,3.302 v 11.303 q 0,0.381 -0.3175,0.381 h -0.92075 q -0.34925,0 -0.34925,-0.381 v -11.2395 q 0,-1.49225 -0.762,-2.31775 -0.762,-0.8255 -2.2225,-0.8255 h -2.06375 q -1.524,0 -2.413,0.8255 -0.85725,0.79375 -0.85725,2.286 v 11.27125 q 0,0.381 -0.34925,0.381 z",
    style: {
      fontFamily: "Rajdhani",
      InkscapeFontSpecification: "Rajdhani"
    },
    id: "path801"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 138.56783,209.95645 v -3.048 q 0,-0.34925 0.3175,-0.34925 h 0.9525 q 0.3175,0 0.3175,0.34925 v 3.048 q 0,0.381 -0.3175,0.381 h -0.9525 q -0.3175,0 -0.3175,-0.381 z m 0,18.4785 v -15.4305 q 0,-0.381 0.3175,-0.381 h 0.92075 q 0.34925,0 0.34925,0.381 v 15.4305 q 0,0.381 -0.3175,0.381 h -0.9525 q -0.3175,0 -0.3175,-0.381 z",
    style: {
      fontFamily: "Rajdhani",
      InkscapeFontSpecification: "Rajdhani"
    },
    id: "path803"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 145.77505,214.0522 h -1.93675 q -0.34925,0 -0.34925,-0.3175 v -0.762 q 0,-0.34925 0.34925,-0.34925 h 1.93675 q 0.28575,0 0.28575,-0.28575 v -2.57175 q 0,-0.381 0.34925,-0.381 h 0.92075 q 0.34925,0 0.34925,0.381 v 2.57175 q 0,0.28575 0.28575,0.28575 h 3.77825 q 0.34925,0 0.34925,0.34925 v 0.762 q 0,0.3175 -0.34925,0.3175 h -3.77825 q -0.28575,0 -0.28575,0.28575 v 10.00125 q 0,1.4605 0.8255,2.25425 0.8255,0.79375 2.31775,0.79375 h 1.23825 q 0.34925,0 0.34925,0.34925 v 0.73025 q 0,0.34925 -0.34925,0.34925 h -1.36525 q -2.0955,0 -3.3655,-1.17475 -1.27,-1.17475 -1.27,-3.2385 v -10.06475 q 0,-0.28575 -0.28575,-0.28575 z",
    style: {
      fontFamily: "Rajdhani",
      InkscapeFontSpecification: "Rajdhani"
    },
    id: "path805"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 162.95181,228.81595 h -2.7305 q -2.06375,0 -3.27025,-1.2065 -1.17475,-1.2065 -1.17475,-3.302 v -7.1755 q 0,-2.0955 1.17475,-3.302 1.2065,-1.2065 3.27025,-1.2065 h 2.7305 q 2.06375,0 3.27025,1.2065 1.2065,1.2065 1.2065,3.302 v 7.1755 q 0,2.0955 -1.2065,3.302 -1.2065,1.2065 -3.27025,1.2065 z m -2.6035,-1.42875 h 2.4765 q 1.4605,0 2.2225,-0.79375 0.79375,-0.8255 0.79375,-2.31775 v -7.112 q 0,-1.49225 -0.79375,-2.286 -0.762,-0.8255 -2.2225,-0.8255 h -2.4765 q -1.4605,0 -2.2225,0.8255 -0.762,0.79375 -0.762,2.286 v 7.112 q 0,1.49225 0.762,2.31775 0.762,0.79375 2.2225,0.79375 z",
    style: {
      fontFamily: "Rajdhani",
      InkscapeFontSpecification: "Rajdhani"
    },
    id: "path807"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 173.08006,228.81595 h -0.92075 q -0.3175,0 -0.3175,-0.381 v -15.4305 q 0,-0.381 0.3175,-0.381 h 0.92075 q 0.34925,0 0.34925,0.381 v 1.3335 h 0.127 q 0.34925,-0.66675 1.23825,-1.17475 0.889,-0.53975 2.19075,-0.53975 h 1.23825 q 0.34925,0 0.34925,0.34925 v 0.762 q 0,0.34925 -0.34925,0.3175 h -1.49225 q -1.55575,0 -2.44475,0.9525 -0.85725,0.9525 -0.85725,2.57175 v 10.8585 q 0,0.381 -0.34925,0.381 z",
    style: {
      fontFamily: "Rajdhani",
      InkscapeFontSpecification: "Rajdhani"
    },
    id: "path809"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkymonitorVerticalNameLogo);
export default __webpack_public_path__ + "static/media/skymonitor-vertical-name-logo.28396028f7817a6a486252f248ce6ec8.svg";
export { ForwardRef as ReactComponent };